import { useNode } from "@craftjs/core";
import React, { useContext, useMemo, useState } from "react";
import TextareaInput from "../../ui-kit/textarea";
import TextInput from "../../ui-kit/text";

import {
  PencilActiveIcon,
  LeftALignIcon,
  LeftALignActiveIcon,
  CenterAlignIcon,
  CenterAlignActiveIcon,
  RightAlignIcon,
  RightAlignActiveIcon,
  PhotoIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";

import {
  ImagePickerUIKit,
  OptionsInput,
  SpacerInput,
  Tabs,
} from "./../../ui-kit";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSImageSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const [srcModal, setSrcModal] = useState(false);
  const { altText, titleText, imageLink, align, src, srcMode } = props;
  const { projectID } = useContext(GrigoraDashboardContext);

  const General = () => {
    return (
      <>
        <SpacerInput>
          <TextareaInput
            minLength={INPUT_LIMITS["image-alt-text"].minlength}
            maxLength={INPUT_LIMITS["image-alt-text"].maxlength}
            label={"Alt Text"}
            value={altText}
            onChange={(val) => {
              setProp((props) => {
                props.altText = val;
              });
            }}
          />
          <TextInput
            minLength={INPUT_LIMITS["image-title"].minlength}
            maxLength={INPUT_LIMITS["image-title"].maxlength}
            hideReset={true}
            label={"Title"}
            value={titleText}
            onChange={(val) => {
              setProp((props) => {
                props.titleText = val.target.value;
              });
            }}
          />
          <TextInput
            minLength={INPUT_LIMITS["outbound-link"].minlength}
            maxLength={INPUT_LIMITS["outbound-link"].maxlength}
            hideReset={true}
            label={"Link"}
            value={imageLink}
            onChange={(val) => {
              setProp((props) => {
                props.imageLink = val.target.value;
              });
            }}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 cursor-default overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar title={"Image"} icon={<PhotoIcon />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
